import { createStyles, makeStyles, Theme } from '@material-ui/core/styles';

const DRAWER_WIDTH = 270;
const CONTOUR = 12;
const ANIMATION_DURATION = 500;

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    list: {
      marginBottom: theme.spacing(10.5),
    },
    drawer: {
      width: DRAWER_WIDTH,
      flexShrink: 0,
      whiteSpace: 'nowrap',
    },
    drawerOpen: {
      width: DRAWER_WIDTH,
      transition: theme.transitions.create('width', {
        easing: theme.transitions.easing.sharp,
        duration: ANIMATION_DURATION,
      }),
    },
    drawerClose: {
      transition: theme.transitions.create('width', {
        easing: theme.transitions.easing.sharp,
        duration: ANIMATION_DURATION,
      }),
      overflowX: 'hidden',
      width: 73,
    },
    drawerPaper: {
      borderTopRightRadius: CONTOUR,
      overflow: 'hidden',
      background: `linear-gradient(${theme.palette.colors.blue}, ${theme.palette.colors.green})`,
    },
    content: {
      flexGrow: 1,
      padding: theme.spacing(3),
    },
    toolbar: theme.mixins.toolbar,
    wrapper: {
      overflow: 'auto',
      '&::-webkit-scrollbar': {
        width: 8.5,
      },
      '&::-webkit-scrollbar-thumb': {
        background: theme.palette.colors.teal,
        borderRadius: 15,
      },
      // scrollbarWidth: 'thin', // Firefox suports
      msOverflowStyle: 'auto', // IE10+ Support
    },
    removeOverflow: {
      overflow: 'hidden',
    },
    colLeft: {
      position: 'fixed',
      width: DRAWER_WIDTH,
      borderTopRightRadius: CONTOUR,
      flex: 1,
      display: 'flex',
      justifyContent: 'flex-start',
      alignItems: 'center',
      zIndex: theme.zIndex.drawer + 1,
      background: theme.palette.colors.blue,
      paddingTop: theme.spacing(3),
      paddingBottom: theme.spacing(3),
      transition: theme.transitions.create('all', {
        easing: theme.transitions.easing.sharp,
        duration: ANIMATION_DURATION,
      }),
    },
    colLeftCloseDrawer: {
      width: 73,
      overflow: 'hidden',
    },
    bdosLogo: {
      width: '8.5rem',
      marginLeft: 16,
    },
    wrapperLogo: {
      display: 'flex',
      overflow: 'hidden',
      transition: theme.transitions.create('width', {
        easing: theme.transitions.easing.sharp,
        duration: ANIMATION_DURATION,
      }),
    },
    shadow: {
      width: 20,
      height: 30,
      background: theme.palette.colors.blue,
      position: 'absolute',
      right: 0,
      marginRight: 0,
    },
    divider: {
      backgroundColor: theme.palette.colors.green,
      margin: theme.spacing(1),
    },
    footerDivider: {
      background: '#ccc',
      margin: theme.spacing(1),
      marginBottom: theme.spacing(2),
    },
    primaryItem: {
      color: theme.palette.colors.white,
      fontWeight: 400,
      marginLeft: theme.spacing(4),
      marginTop: 2,
    },
    secondaryItem: {
      color: theme.palette.text.secondary,
      fontSize: 14,
      whiteSpace: 'nowrap',
      overflow: 'hidden',
      textOverflow: 'ellipsis',
    },
    menuItemBadge: {
      display: 'inline-block',
      marginLeft: theme.spacing(1),
      padding: '0 6px',
      minWidth: 18,
      height: 18,
      lineHeight: '18px',
      borderRadius: 9,
      textAlign: 'center',
      fontSize: 12,
      fontWeight: 600,
      color: theme.palette.colors.white,
      background: theme.palette.error.main,
    },
    company: {
      display: 'flex',
      padding: '15px 10px',
      paddingRight: 0,
      justifyContent: 'space-between',
      alignItems: 'center',
    },
    companyLogo: {
      minWidth: theme.spacing(5),
      width: theme.spacing(5),
      height: theme.spacing(5),
      background: '#ddd',
      padding: 3,
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      borderRadius: 5,
    },
    companyLabel: {
      fontSize: theme.spacing(2),
      fontWeight: 'bold',
      marginLeft: 7,
      whiteSpace: 'nowrap',
      overflow: 'hidden',
      textOverflow: 'ellipsis',
    },
    primaryScope: {
      display: 'flex',
    },
    drawerIcon: {
      width: '22px !important',
      height: '22px !important',
    },
    drawerIconMargin: {
      marginLeft: 10,
    },
    opacity: {
      opacity: 0.6,
    },
    collapse: {
      position: 'fixed',
      bottom: 0,
      width: DRAWER_WIDTH,
      zIndex: theme.zIndex.drawer + 1,
      background: theme.palette.colors.green,
      transition: theme.transitions.create('all', {
        easing: theme.transitions.easing.sharp,
        duration: ANIMATION_DURATION,
      }),
      padding: theme.spacing(1),
    },
    collpaseSmall: {
      transition: theme.transitions.create('all', {
        easing: theme.transitions.easing.sharp,
        duration: ANIMATION_DURATION,
      }),
      overflowX: 'hidden',
      width: 73,
    },
    iconCollapse: {
      color: theme.palette.colors.white,
    },
    item: {
      paddingLeft: 0,
    },
    title: {
      marginLeft: 0,
    },
    subtitle: {
      marginLeft: 24,
    },
  }),
);

export default useStyles;
